export function sanitizePhoneInput(value: string): string {
  return value.replace(/[^\d\s]/g, "");
}

export function isValidPhoneNumber(value: string): boolean {
  return value.replace(/\D/g, "").length >= 6;
}

export function formatPhoneForApi(dialCode: string, phone: string): string {
  const digits = phone.replace(/\s+/g, "");
  const code = dialCode.trim();
  if (!digits) return "";

  if (digits.startsWith("+")) return digits;
  if (digits.startsWith(code.replace("+", ""))) return `+${digits}`;
  return `${code}${digits}`;
}
